module.exports = __webpack_public_path__ + "static/media/44.6dbdeee3.jpg";